import moment from "moment";
import { EEvGraphViewType } from "../enums/ev-graph-view-type";

export const getViewType = (tabId: number): EEvGraphViewType => {
  switch (tabId) {
    case 1:
      return EEvGraphViewType.HOUR;
    case 2:
      return EEvGraphViewType.DAY;
    case 3:
      return EEvGraphViewType.MONTH;
    default:
      return EEvGraphViewType.MONTH;
  }
};

export const calculateDateRange = (
  date: Date,
  viewType: EEvGraphViewType,
  zoneOffset = "+05:30",
) => {
  const formattedDate = moment(date);
  let startStr = "";
  let endStr = "";

  if (viewType === EEvGraphViewType.HOUR) {
    const dayStr = formattedDate.format("YYYY-MM-DD");
    startStr = `${dayStr}T00:00:00.000${zoneOffset}`;
    endStr = `${dayStr}T23:59:59.999${zoneOffset}`;
  } else if (viewType === EEvGraphViewType.DAY) {
    const startOfMonth = formattedDate
      .clone()
      .startOf("month")
      .format("YYYY-MM-DD");
    const endOfMonth = formattedDate
      .clone()
      .endOf("month")
      .format("YYYY-MM-DD");
    startStr = `${startOfMonth}T00:00:00.000${zoneOffset}`;
    endStr = `${endOfMonth}T23:59:59.999${zoneOffset}`;
  } else if (
    viewType === EEvGraphViewType.MONTH ||
    viewType === EEvGraphViewType.YEAR
  ) {
    const startOfYear = formattedDate
      .clone()
      .startOf("year")
      .format("YYYY-MM-DD");
    const endOfYear = formattedDate.clone().endOf("year").format("YYYY-MM-DD");
    startStr = `${startOfYear}T00:00:00.000${zoneOffset}`;
    endStr = `${endOfYear}T23:59:59.999${zoneOffset}`;
  }

  return {
    startDate: moment(startStr).toISOString(),
    endDate: moment(endStr).toISOString(),
  };
};

export const getGraphDateDisplay = (date: Date, viewType: EEvGraphViewType) => {
  if (viewType === EEvGraphViewType.HOUR)
    return moment(date).format("YYYY.MM.DD");
  if (viewType === EEvGraphViewType.DAY) return moment(date).format("YYYY.MM");
  return moment(date).format("YYYY");
};

export const getDatePickerFormat = (viewType: EEvGraphViewType) => {
  if (viewType === EEvGraphViewType.HOUR) return "dd MMMM yyyy";
  if (viewType === EEvGraphViewType.DAY) return "MMMM yyyy";
  return "yyyy";
};

export const getXAxisLabel = (viewType: EEvGraphViewType) => {
  if (viewType === EEvGraphViewType.HOUR) return "Hour";
  if (viewType === EEvGraphViewType.DAY) return "Day";
  if (viewType === EEvGraphViewType.MONTH) return "Month";
  return "Year";
};

export const formatGraphPointLabel = (
  periodStart: string | undefined,
  viewType: EEvGraphViewType,
) => {
  if (!periodStart) return "";
  const m = moment(periodStart);
  if (viewType === EEvGraphViewType.HOUR) {
    return m.format("HH:mm");
  } else if (viewType === EEvGraphViewType.DAY) {
    return m.format("D");
  } else if (viewType === EEvGraphViewType.MONTH) {
    return m.format("MMM");
  }
  return m.format("YYYY");
};
